import { render, staticRenderFns } from "./EvaluateScore.vue?vue&type=template&id=3148c884&scoped=true&"
import script from "./EvaluateScore.vue?vue&type=script&lang=js&"
export * from "./EvaluateScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3148c884",
  null
  
)

export default component.exports